import { createCol, createCol1 } from "../services/epox/views";
import { Box, BoxProps } from "./box";

export const Col = createCol<BoxProps>(Box);

export const Col1 = createCol1<BoxProps>(Box);
